export default __webpack_public_path__ + "static/media/Shape.a2e628df.svg";